import { render, staticRenderFns } from "./VMSelectOptions.vue?vue&type=template&id=3e43b765&lang=pug&"
import script from "./VMSelectOptions.vue?vue&type=script&lang=js&"
export * from "./VMSelectOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports